(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["home-country-query"] && !Shopify.designMode) return;
  try {
    const { pathname, search, origin } = window.location;

if ((pathname === '/' || pathname === '') && search.includes('country=')) {
  window.history.replaceState({}, '', origin + '/');
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plp-facet-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
if (!document.querySelector('.hdt-main-collection-content, .hdt-main-search')) return;

let _hdtFacetLayoutUnlockTimer = 0;
let _hdtFacetLayoutStyleInjected = false;

function ensureFacetLayoutLockStyle() {
  if (_hdtFacetLayoutStyleInjected || document.getElementById('hdt-facet-layout-lock-style')) return;
  const style = document.createElement('style');
  style.id = 'hdt-facet-layout-lock-style';
  style.textContent = `
    @media (min-width: 1150px) {
      [main-content][data-facet-layout-lock="1"] .hdt-row-flex .hdt-shop-sidebar.hdt-col {
        width: var(--hdt-facet-sidebar-width) !important;
        min-width: var(--hdt-facet-sidebar-width) !important;
        max-width: var(--hdt-facet-sidebar-width) !important;
        flex: 0 0 var(--hdt-facet-sidebar-width) !important;
      }
      [main-content][data-facet-layout-lock="1"] .hdt-row-flex .hdt-shop-content.hdt-col,
      [main-content][data-facet-layout-lock="1"] .hdt-row-flex .hdt-search-results-content.hdt-col {
        width: var(--hdt-facet-content-width) !important;
        min-width: var(--hdt-facet-content-width) !important;
        max-width: var(--hdt-facet-content-width) !important;
        flex: 0 0 var(--hdt-facet-content-width) !important;
      }
    }
    [main-content][data-facet-layout-lock="1"] .hdt-active-filters {
      min-height: var(--hdt-facet-active-filters-height, auto) !important;
    }
    [main-content][data-facet-layout-lock="1"] .hdt-row-flex {
      min-height: var(--hdt-facet-row-min-height, auto) !important;
    }
  `;
  document.head.appendChild(style);
  _hdtFacetLayoutStyleInjected = true;
}

function getFacetMainContentFromEvent(event) {
  const sectionFromTarget = event?.target?.closest?.('.shopify-section');
  if (sectionFromTarget) {
    return sectionFromTarget.querySelector('[main-content]');
  }

  const sectionIdFromUrl = event?.detail?.url?.searchParams?.get?.('section_id');
  if (sectionIdFromUrl) {
    return document.getElementById(`shopify-section-${sectionIdFromUrl}`)?.querySelector('[main-content]');
  }

  return document.querySelector('[main-content]');
}

function lockFacetLayoutDuringRender(event) {
  if (window.innerWidth < 1150) return;
  const mainContent = getFacetMainContentFromEvent(event);
  if (!mainContent) return;
  ensureFacetLayoutLockStyle();

  const row = mainContent.querySelector('.hdt-row-flex');
  if (!row) return;

  const sidebar = row.querySelector('.hdt-shop-sidebar.hdt-col');
  const content = row.querySelector('.hdt-shop-content.hdt-col, .hdt-search-results-content.hdt-col');
  if (!sidebar || !content) return;

  const sidebarWidth = Math.round(sidebar.getBoundingClientRect().width);
  const contentWidth = Math.round(content.getBoundingClientRect().width);
  const rowHeight = Math.round(row.getBoundingClientRect().height);

  if (sidebarWidth > 80) {
    mainContent.style.setProperty('--hdt-facet-sidebar-width', `${sidebarWidth}px`);
  }

  if (contentWidth > 120) {
    mainContent.style.setProperty('--hdt-facet-content-width', `${contentWidth}px`);
  }

  if (rowHeight > 120) {
    mainContent.style.setProperty('--hdt-facet-row-min-height', `${rowHeight}px`);
  }

  const activeFilters = mainContent.querySelector('.hdt-active-filters');
  if (activeFilters) {
    const activeHeight = Math.round(activeFilters.getBoundingClientRect().height);
    if (activeHeight > 0) {
      mainContent.style.setProperty('--hdt-facet-active-filters-height', `${activeHeight}px`);
    }
  }

  mainContent.dataset.facetLayoutLock = '1';
}

function unlockFacetLayoutAfterRender() {
  clearTimeout(_hdtFacetLayoutUnlockTimer);
  _hdtFacetLayoutUnlockTimer = setTimeout(() => {
    document.querySelectorAll('[main-content][data-facet-layout-lock="1"]').forEach((mainContent) => {
      mainContent.style.removeProperty('--hdt-facet-sidebar-width');
      mainContent.style.removeProperty('--hdt-facet-content-width');
      mainContent.style.removeProperty('--hdt-facet-row-min-height');
      mainContent.style.removeProperty('--hdt-facet-active-filters-height');
      delete mainContent.dataset.facetLayoutLock;
    });
  }, 180);
}

function initFacetSingleOpenAccordions(dom = document) {
  const facetForms = dom.querySelectorAll('hdt-facet-filters-form');
  facetForms.forEach((facetForm) => {
    const groups = facetForm.querySelectorAll('details.hdt-filter-group');
    if (!groups.length) return;
    groups.forEach((group) => {
      if (group.dataset.singleFacetBound === '1') return;
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        groups.forEach((otherGroup) => {
          if (otherGroup !== group) {
            otherGroup.removeAttribute('open');
          }
        });
      });
      group.dataset.singleFacetBound = '1';
    });

    const openGroups = Array.from(groups).filter((group) => group.open);
    if (openGroups.length === 0) {
      groups[0].setAttribute('open', '');
      return;
    }

    if (openGroups.length > 1) {
      openGroups.forEach((group, index) => {
        if (index > 0) {
          group.removeAttribute('open');
        }
      });
    }
  });
}

function onGloboSwatchClick(event) {
  const swatch = event.target.closest('.spf-product__swatch');
  if (!swatch) return;

  const swatchGroup = swatch.closest('.spf-product__swatchs');
  const productCard = swatch.closest('.spf-product-card');
  const selectEl = productCard?.querySelector('select.spf-product__variants');
  const addToCartBtn = productCard?.querySelector('.hdt-button-add-to-cart__btn');
  if (!swatchGroup || !selectEl || !addToCartBtn) return;

  swatchGroup.querySelectorAll('.spf-product__swatch').forEach((item) => item.classList.remove('is-selected'));
  swatch.classList.add('is-selected');

  const selectedValues = {};
  productCard.querySelectorAll('.spf-product__swatchs .spf-product__swatch.is-selected').forEach((item) => {
    const optIndex = item.getAttribute('data-option');
    const optValue = item.getAttribute('data-option-value');
    selectedValues[`data-option${optIndex}`] = optValue;
  });

  const matchedOption = Array.from(selectEl.options).find((option) => {
    return Object.entries(selectedValues).every(([key, value]) => option.getAttribute(key) === value);
  });

  if (matchedOption) {
    addToCartBtn.setAttribute('data-variant-id', matchedOption.value);
    selectEl.value = matchedOption.value;
  }
}

document.addEventListener('facet:render', lockFacetLayoutDuringRender);
['theme4:facet:updated', 'hdt:facet:render'].forEach((eventName) => {
  document.addEventListener(eventName, (event) => {
    lockFacetLayoutDuringRender(event);
    const root = getFacetMainContentFromEvent(event) || document;
    root.dispatchEvent(new CustomEvent('products:update', { bubbles: true }));
  });
});
document.addEventListener('mox:products:ready', (event) => {
  initFacetSingleOpenAccordions(event.target);
  unlockFacetLayoutAfterRender();
});

window.addEventListener('globoFilterRenderCompleted', () => {
  if (!window.__hdtGloboSwatchBound) {
    document.addEventListener('click', onGloboSwatchClick);
    window.__hdtGloboSwatchBound = true;
  }

  const root = document.querySelector('[main-content]') || document;
  root.dispatchEvent(new CustomEvent('products:update', { bubbles: true }));
});

initFacetSingleOpenAccordions(document);
})();
  } catch(e) { console.error(e); }
})();

})();
